import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBs39_f9J2Ls2kFgND9UL0ZR54RCimzkHE",
  authDomain: "amdavad-post-a6f94.firebaseapp.com",
  // ...other config values
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();